<template>
  <div class="container">
    <div class="column is-8 is-offset-2">

      <b-message v-if="!isLogin" type="is-warning" has-icon>
        作成するにはログインが必要です。<br>
        (アカウント登録も行えます。)
      </b-message>

      <p class="title">
        イベント作成
      </p>

      <section>
        <b-field label="開催日">
          <b-datepicker
            :month-names="['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']"
            :min-date="minDate"
            v-model="newDate"
            placeholder="日付を選択してください"
            icon="calendar-today"
            editable
            required>
          </b-datepicker>
        </b-field>

        <b-field label="開始時間">
          <b-timepicker
            v-model="newStart"
            placeholder="開始時間を選択してください"
            icon="clock"
            editable
            required>
          </b-timepicker>
        </b-field>

        <b-field label="終了時間">
          <b-timepicker
            v-model="newEnd"
            placeholder="終了時間を選択してください"
            icon="clock"
            editable
            required>
          </b-timepicker>
        </b-field>

        <b-field label="場所">
          <div class="control has-icons-left is-clearfix">
            <gmap-autocomplete class="introInput input"
              placeholder="コート名を入力ください"
              @place_changed="setPlace">
            </gmap-autocomplete>
            <span class="icon is-left is-clickable">
              <b-icon icon="magnify" pack="mdi"></b-icon>
            </span>
          </div>
        </b-field>

        <div class="column is-half">
            <b-field label="募集人数">
              <b-numberinput
                v-model="newRecruitment"
                min="1"
                required
                type="is-light">
              </b-numberinput>
            </b-field>
        </div>

        <b-field label="メモ">
          <b-input
            v-model="newMemo"
            placeholder="レベルや金額など参加者に伝えたいことをお書きください。"
            maxlength="500"
            required
            type="textarea">
          </b-input>
        </b-field>
      </section>

      <div v-if="isLogin && place != null" v-on:click="createEvent">
        <b-button type="is-primary">
          登録
        </b-button>
      </div>
      <div v-else>
        <b-button disabled>
          登録
        </b-button>
      </div>

    </div>
  </div>
</template>

<script>
import firebase from '@/firebase/firebase'
var db = firebase.firestore();

export default {
  name: 'create-event',
  props: ['currentUser', 'isLogin'],
  data () {
    const today = new Date()

    return {
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 0),
      place: null,
      newDate: null,
      newStart: null,
      newEnd: null,
      newRecruitment: null,
      newMemo: null
    }
  },
  methods: {
    setPlace(place) {
      this.place = place
    },
    createEvent: function() {
      var confirmCreate = confirm('この内容でイベントを作成しますか？日時とコート名は作成後変更できませんのでご注意ください。');

      if(confirmCreate) {
        if(this.isLogin) {
          const newStartDateTime = new Date(
            this.newDate.getFullYear(),
            this.newDate.getMonth(),
            this.newDate.getDate(),
            this.newStart.getHours(),
            this.newStart.getMinutes()
          )

          const newEndDateTime = new Date(
            this.newDate.getFullYear(),
            this.newDate.getMonth(),
            this.newDate.getDate(),
            this.newEnd.getHours(),
            this.newEnd.getMinutes()
          )

          const newPoint = new firebase.firestore.GeoPoint(
            this.place.geometry.location.lat(),
            this.place.geometry.location.lng()
          )

          // Add a new document with a generated id.
          db.collection("events").add({
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            start: newStartDateTime,
            end: newEndDateTime,
            memo: this.newMemo,
            recruitment: this.newRecruitment,
            courtName: this.place.name,
            point: newPoint,
            ownerID: this.currentUser.uid,
            ownerName: this.currentUser.displayName,
            canceled: false
          })
          .then(docRef => {
            console.log("Event written with ID: ", docRef.id)
            this.$router.push({ name: 'event-detail', params: { event: docRef.id }})
          })
          .catch(function(error) {
              console.error("Error adding document: ", error);
          });
        }
      } else {
        console.log('You need login or signup.')
      }
    },
    // // dele
    // postTweet(newStartDateTime) {
    //   var Twitter = require('twitter');
    //
    //   var client = new Twitter({
    //     consumer_key: this.$tw_consumer_key,
    //     consumer_secret: this.$tw_consumer_secret,
    //     access_token_key: this.$tw_access_token_key,
    //     access_token_secret: this.$tw_access_token_secret
    //   });
    //
    //   const day = this.$moment(newStartDateTime).format("YYYY年M月D日(ddd)")
    //   const time = this.$moment(newStartDateTime).format("k:mm")
    //   const tweet_content = day + ' ' + time + '- @' + this.place.name
    //
    //   client.post(
    //     'statuses/update',
    //     {status: tweet_content},
    //     function(error, tweet, response) {
    //       if(error) throw error;
    //       console.log(tweet);  // Tweet body.
    //       console.log(response);  // Raw response object.
    //   });
    // }
  }
}
</script>

<style>
</style>
